export const formatTime = (value) => {
  if (!value) return ''
  try {
    if (typeof value === 'string') {
      const timeMatch = value.match(/^(\d{2}):(\d{2})(?::(\d{2}))?$/)

      if (timeMatch) {
        const h = Number.parseInt(timeMatch[1], 10)
        const m = Number.parseInt(timeMatch[2], 10)
        const ampm = h >= 12 ? 'PM' : 'AM'
        const h12 = h % 12 || 12

        if (Number.isNaN(h) || Number.isNaN(m)) return ''

        return `${String(h12).padStart(2, '0')}:${String(m).padStart(2, '0')} ${ampm}`
      }
    }

    const d = new Date(value)

    if (Number.isNaN(d.getTime())) return ''

    const h = d.getHours()
    const m = d.getMinutes()
    const ampm = h >= 12 ? 'PM' : 'AM'
    const h12 = h % 12 || 12

    return `${String(h12).padStart(2, '0')}:${String(m).padStart(2, '0')} ${ampm}`
  } catch {
    return ''
  }
}

export const formatDate = (isoString) => {
  if (!isoString) return ''
  try {
    const d = new Date(isoString)
    const today = new Date()
    const isToday = d.getDate() === today.getDate() && d.getMonth() === today.getMonth() && d.getFullYear() === today.getFullYear()

    if (isToday) return 'Today'

    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }

    return d.toLocaleDateString('en-US', options)
  } catch {
    return ''
  }
}

export const formatDateTime = (isoString) => {
  if (!isoString) return ''
  try {
    const d = new Date(isoString)

    if (Number.isNaN(d.getTime())) return ''

    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    }

    return d.toLocaleString('en-US', options)
  } catch {
    return ''
  }
}

export const getRepeatLabel = (reminder) => {
  if (!reminder) return ''
  const type = reminder.repeat_type || 'daily'
  const days = Array.isArray(reminder.custom_days) ? reminder.custom_days : []
  const DAY_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

  if (type === 'once') return 'Once'
  if (type === 'weekdays') return 'Mon - Fri'
  if (type === 'custom') {
    if (!days.length) return 'Custom'
    const labels = days.map((d) => DAY_LABELS[d] ?? '').filter(Boolean)

    return labels.length ? `Custom: ${labels.join(', ')}` : 'Custom'
  }

  return 'Daily'
}
